import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSwaggerComponent } from './simple-icons-swagger.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSwaggerComponent ],
    exports:      [ SimpleIconsSwaggerComponent ],
    bootstrap:    []
})
export class SimpleIconsSwaggerModule {}
